import { api } from '@cwd/lib/main';

export interface CurrentUser {
    UserId: string;
    FirstName: string;
    LastName: string;
    Email: string;
    MobilePhone: string;
    LanguageId: string;
    Personnummer: string | null;
    HasPersonnummer: boolean;
}

export interface PasswordChange {
    CurrentPassword: string;
    NewPassword: string;
    PasswordConfirmation: string;
}

export async function getCurrentUser(): Promise<CurrentUser> {
    return api.get('/Users/Current');
}

export async function updateCurrentUserProperty(property: string, value: string): Promise<CurrentUser> {
    return api.post('/Users/Current/' + property, value);
}

export async function switchLanguage(language: { LanguageId: string; Culture: string }): Promise<any> {
    return api.post('/User/Language', language);
}

export async function changeCurrentUserPassword(passwordChange: PasswordChange): Promise<void> {
    // Bypasses api.post: a wrong current password is a 401 from this endpoint, but api.post treats
    // any 401 as an expired session and redirects to sign-in instead of surfacing the form error.
    const authOptions = api.beforeSend(api.settings);
    const url = (api.settings.apiHost || '') + '/Users/Current/Password';
    const headers = authOptions.headers as Record<string, string>;

    const response = await fetch(url, {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json; charset=UTF-8' },
        body: JSON.stringify(passwordChange),
    });

    if (response.ok) return;

    const message = await response.text();
    throw { status: response.status, statusText: response.statusText, message };
}
